import { FC } from "react";
import Grid from "@mui/material/Grid";
import BreadCrumb from "../../components/Breadcrumbs/Breadcrumbs";
import Estimate from '../../components/Invoice/Estimate';

interface EstimateFormProps {
  type: string;
}

// Create/edit Estimate page
const EstimateForm: FC<EstimateFormProps> = ({type}) => {
  return (
    <>
      <BreadCrumb />
      <Grid rowSpacing="36" columnSpacing="22" container>
        <Grid item xs={12} md={12} lg={12}>
          <Estimate type={type}/>
        </Grid>
      </Grid>
    </>
  );
};

export default EstimateForm;
